<template>
    <el-dialog :title="(productId === null ? $t('common.create') : $t('common.update')) + ' ' + $t('masters.product')" :visible.sync="showDialog" @open="loadProduct" @close="closeDialog" width="500px" :close-on-click-modal="false">
        <el-form v-loading="loading" ref="form" :model="form" :rules="rules" size="small" label-width="140px" label-position="left">
            <el-form-item :label="$t('common.number')" prop="no">
                <el-input v-model="form.no"></el-input>
            </el-form-item>

            <el-form-item :label="$t('common.name')" prop="name">
                <el-input v-model="form.name"></el-input>
            </el-form-item>
            
            <el-form-item :label="$t('common.altName')" prop="altName">
                <el-input v-model="form.altName"></el-input>
            </el-form-item>

            <el-form-item :label="$t('common.model')" prop="model">
                <el-input v-model="form.model"></el-input>
            </el-form-item>

            <el-form-item :label="$t('masters.serialPrefix')" prop="serialPrefix">
                <el-input v-model="form.serialPrefix"></el-input>
            </el-form-item>

            <el-form-item :label="$t('masters.laborGLCode')" prop="laborGLCode" v-mask="'####-###-###'">
                <el-input v-model="form.laborGLCode"></el-input>
            </el-form-item>

            <el-form-item :label="$t('masters.partGLCode')" prop="partGLCode" v-mask="'####-###-###'">
                <el-input v-model="form.partGLCode"></el-input>
            </el-form-item>

            <el-form-item :label="$t('masters.handlingGLCode')" prop="handlingGLCode" v-mask="'####-###-###'">
                <el-input v-model="form.handlingGLCode"></el-input>
            </el-form-item>

            <el-form-item :label="$t('masters.freightGLCode')" prop="freightGLCode" v-mask="'####-###-###'">
                <el-input v-model="form.freightGLCode"></el-input>
            </el-form-item>

            <el-form-item :label="$t('masters.miscGLCode')" prop="miscGLCode" v-mask="'####-###-###'">
                <el-input v-model="form.miscGLCode"></el-input>
            </el-form-item>

            <el-form-item :label="$t('masters.note')" prop="note">
                <el-input type="textarea" v-model="form.note" autosize></el-input>
            </el-form-item>

        </el-form>
        <span slot="footer">
            <el-button :disabled="loading" type="primary" @click="save" v-if="$isFullAdmin">{{productId === null ? $t('common.create') : $t('common.update')}}</el-button>
            <el-button :disabled="loading" @click="closeDialog">{{$t('common.cancel')}}</el-button>
        </span>
    </el-dialog>
</template>

<script>
    import api from '../api'

    const glCodeValidator = {
        validator: (rule, value, callback) => {
            if (/^\d{4}-\d{3}-\d{3}$/.test(value)) {
                callback();
            } else {
                callback('Use XXXX-XXX-XXX format.');
            }
        },
            trigger: 'blur'
    };

    export default {
        name: 'create-update-product-dialog',
        props: {
            visible: {
                type: Boolean,
                default: false
            },
            productId: {
                required: false
            }
        },
        data() {
            return {
                form: {
                    no: undefined,
                    name: undefined,
                    altName: undefined,
                    model: undefined,
                    serialPrefix: undefined,
                    laborGLCode: undefined,
                    partGLCode: undefined,
                    handlingGLCode: undefined,
                    freightGLCode: undefined,
                    miscGLCode: undefined,
                    note: undefined
                },
                rules: {
                    no: [
                        {
                            required: true,
                            message: this.$t('common.pleaseEnterProductNumber'),
                            trigger: 'blur'
                        }
                    ],
                    name: [
                        {
                            required: true,
                            message: this.$t('common.pleaseEnterProductName'),
                            trigger: 'blur'
                        }
                    ],
                    model: [
                        {
                            required: true,
                            message: this.$t('common.pleaseEnterModel'),
                            trigger: 'blur'
                        }
                    ],
                    serialPrefix: [
                        {
                            required: true,
                            message: this.$t('common.pleaseEnterSerialPrefix'),
                            trigger: 'blur'
                        }
                    ],
                    laborGLCode: [
                        {
                            required: true,
                            message: this.$t('common.pleaseEnterLaborGLCode'),
                            trigger: 'blur'
                        },
                        glCodeValidator
                    ],
                    partGLCode: [
                        {
                            required: true,
                            message: this.$t('common.pleaseEnterPartGLCode'),
                            trigger: 'blur'
                        },
                        glCodeValidator
                    ],
                    handlingGLCode: [
                        {
                            required: true,
                            message: this.$t('common.pleaseEnterHandlingGLCode'),
                            trigger: 'blur'
                        },
                        glCodeValidator
                    ],
                    freightGLCode: [
                        {
                            required: true,
                            message: this.$t('common.pleaseEnterFreightGLCode'),
                            trigger: 'blur'
                        },
                        glCodeValidator
                    ],
                    miscGLCode: [
                        {
                            required: true,
                            message: this.$t('common.pleaseEnterMiscGLCode'),
                            trigger: 'blur'
                        },
                        glCodeValidator
                    ]
                },
                loading: false,
                showDialog: this.visible
            }
        },
        watch: {
            visible: function (val) {
                this.showDialog = val
            }
        },
        methods: {
            loadProduct() {
                if (this.productId) {
                    this.loading = true
                    api.getProduct(this.productId).then(response => {
                        this.loading = false
                        this.form = Object.assign({}, response.data)
                    })
                }
            },
            closeDialog() {
                this.$refs['form'].resetFields()
                this.showDialog = false
                this.loading = false
                this.$emit('dialogClosed')
            },
            save() {
                this.$refs['form'].validate(valid => {
                    if (valid) {
                        this.loading = true
                        api.saveProduct(this.productId, this.form).then((response) => {
                            this.$emit('save', {
                                new: this.productId === undefined,
                                id: this.productId,
                                data: this.form
                            })
                            this.closeDialog()
                        }).catch(err => {
                            this.loading = false;
                            this.$message(this.$t('common.creationFailed'))
                        })
                    } else {
                        return false
                    }
                })
            }
        }
    }
</script>



// WEBPACK FOOTER //
// ClientApp/app/masters/products/components/CreateUpdateProductDialog.vue